export default "__VITE_ASSET__ZSqmRP0m__"